export function convertToCamelCase<T>(obj: T) {
    if (Array.isArray(obj)) {
        return obj.map(item => convertToCamelCase(item));
    } else if (obj !== null && typeof obj === "object") {
        return Object.keys(obj).reduce((acc, key) => {
            const camelCaseKey = key.replace(/([-_][a-z])/g, group => group.toUpperCase().replace("-", "").replace("_", ""));
            acc[camelCaseKey] = convertToCamelCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}

/**
 * Highlights occurrences of searchText in the given text by wrapping them in <b> tags.
 *
 * @param text - The text to search in
 * @param searchText - The string to highlight
 * @param minChars - Minimum characters required to trigger highlighting (optional, default 2)
 * @param highlightStyleColor - HTML style for highlighted text (optional, default black)
 * @returns HTML string with highlighted matches
 */
export function highlightText(
    text: string,
    searchText: string | null | undefined,
    minChars: number = 2,
    highlightStyleColor: string = "#000000"
): string {
    text = text != null ? String(text) : "";
    searchText = searchText?.trim();
    if (!searchText || searchText?.length < minChars) {
        return text;
    }
    const regex = new RegExp(`(${searchText})`, "gi");
    return text.replace(regex, `<b style="color:${highlightStyleColor}">$1</b>`);
}
